import { createDomain } from 'effector';

import api from 'api';

const domain = createDomain('api/stripe');

const StripeFxs = {
    getCouponsFx: domain.effect(api.stripe.getCoupons),
    shippingPaymentFx: domain.effect(api.stripe.shippingPayment),
    giftPaymentFx: domain.effect(api.stripe.giftPayment),
    createTapfiliateRecordFx: domain.effect(api.stripe.createTapfiliateRecord),
};

export default StripeFxs;
